import SvgIcon from "@material-ui/core/SvgIcon";
import React from "react";

export const BrokenPalletIcon = (props) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		{/* Layer 3 (top) - empty */}
		<rect
			x="3"
			y="2"
			width="8.5"
			height="5"
			rx="0.5"
			fill="none"
			stroke="#BDBDBD"
			strokeWidth="0.8"
		/>
		<rect
			x="12.5"
			y="2"
			width="8.5"
			height="5"
			rx="0.5"
			fill="none"
			stroke="#BDBDBD"
			strokeWidth="0.8"
		/>
		{/* Layer 2 (middle) - left empty, right filled */}
		<rect
			x="3"
			y="7.5"
			width="8.5"
			height="5"
			rx="0.5"
			fill="none"
			stroke="#BDBDBD"
			strokeWidth="0.8"
		/>
		<rect x="12.5" y="7.5" width="8.5" height="5" rx="0.5" fill="#4CAF50" />
		{/* Layer 1 (bottom) - green */}
		<rect x="3" y="13" width="8.5" height="5" rx="0.5" fill="#4CAF50" />
		<rect x="12.5" y="13" width="8.5" height="5" rx="0.5" fill="#4CAF50" />
		{/* Pallet base */}
		<rect x="2" y="20" width="20" height="2" rx="0.5" fill="#8D6E63" />
		<rect x="3" y="18" width="2" height="2" fill="#8D6E63" />
		<rect x="11" y="18" width="2" height="2" fill="#8D6E63" />
		<rect x="19" y="18" width="2" height="2" fill="#8D6E63" />
	</SvgIcon>
);
